import React, { useState, useEffect } from "react";
import { corefetch } from "../../../Util/axios_core_helper";

export const RentalHighlights = () => {
  const [mainDescription, setMainDescription] = useState("");
  const [subDatas, setSubDatas] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedHighlights, setSelectedHighlights] = useState(null);

  const fetchData = async () => {
    try {
      const response = await corefetch("RentalHighlights/GetMainDescription");
      if (response && response.length > 0) {
        setMainDescription(response[0].mainDescription);
      } else {
        console.log("No main description found");
      }
    } catch (error) {
      console.error("Error fetching main description:", error);
    }
  };

  const fetchSubData = async () => {
    try {
      const response = await corefetch(
        "RentalHighlights/GetRentalHighlightsDetails"
      );
      if (response && response.length > 0) {
        setSubDatas(response);
      } else {
        console.log("No rental highlights details found");
      }
    } catch (error) {
      console.error("Error fetching rental highlights details:", error);
    }
  };

  useEffect(() => {
    fetchData();
    fetchSubData();
  }, []);

  const openModal = (data) => {
    setSelectedHighlights(data);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setSelectedHighlights(null);
    setIsModalOpen(false);
  };

  useEffect(() => {
    if (subDatas?.length) {
      $(".amenities .owl-carousel").owlCarousel({
        loop: true,
        margin: 30,
        mouseDrag: true,
        autoplay: true,
        dots: true,
        autoplayHoverPause: true,
        nav: false,
        navText: [
          "<span class='lnr ti-angle-left'></span>",
          "<span class='lnr ti-angle-right'></span>",
        ],
        responsiveClass: true,
        responsive: {
          0: {
            items: 1,
          },
          600: {
            items: 2,
          },
          1000: {
            items: 3,
          },
        },
      });
    }
  }, [JSON.stringify(subDatas)]);

  if (!mainDescription) {
    return null;
  }

  return (
    <>
      <section className="amenities">
        <div className="container">
          <div className="row mb-30">
            <div className="col-md-3">
              <div className="sub-title border-bot-light">Discover</div>
            </div>
            <div className="col-md-9">
              <div className="section-title">Rental Highlights</div>
              <p>{mainDescription}</p>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="owl-carousel owl-theme">
                {subDatas.map((data, index) => (
                  <div
                    className="item rental"
                    // style={{ height: "300px" }}
                    key={data.rentalHighlightsID}
                  >
                    <span className="number">{index + 1}</span>
                    <div className="icon">
                      <i className="flaticon-world"></i>
                    </div>
                    <h5>
                      <a
                        onClick={() => openModal(data)}
                        style={{ cursor: "pointer" }}
                      >
                        {data.title}
                      </a>
                    </h5>
                    <p
                      onClick={() => openModal(data)}
                      style={{
                        display: "inline-block",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        // Fixed height
                        lineHeight: "1.5em", // Control line height to ensure proper clipping
                        cursor: "pointer",
                      }}
                    >
                      {data.description}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
      {isModalOpen && selectedHighlights && (
        <div id="ServiceModal" className="popup">
          <div className="modal-content">
            <span className="close" onClick={closeModal}>
              &times;
            </span>
            <div className="modal-header">{selectedHighlights.title}</div>
            <div className="additional-text">
              <p>{selectedHighlights.description}</p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
